export default __webpack_public_path__ + "static/media/gym-img-03.b8f3987e.jpg";